module.exports = __webpack_public_path__ + "img/1.8a6f53d8.jpg";